<div class="card">
  <div class="card-body">
    <p class="card-title font-weight-bold">{{title}}</p>
    <p class="card-subtitle text-muted">
      {{fileName}}
    </p>

    <button class="btn btn-sm btn-primary" (click)="download()" id="downloadButton">
        <ng-container *ngIf="isTrigger">
            Export erzeugen
        </ng-container>
        <ng-container *ngIf="!isTrigger">
            Herunterladen
        </ng-container>
    </button>
  </div>
</div>
